import { isDevMode } from '@angular/core';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideRouterStore } from '@ngrx/router-store';

import { reducers } from './reducers';
import { CompanyEffects } from './effects/company.effects';
import { LayoutEffects } from './effects/layout.effects';
import { RouterEffects } from './effects/router.effects';
import { UserEffects } from './effects/user.effects';

export const romeoStoreProviders = [
  provideStore(reducers, {
    runtimeChecks: {
      strictStateImmutability: true,
      strictActionImmutability: true,
    },
  }),

  provideEffects([RouterEffects, LayoutEffects, UserEffects, CompanyEffects]),

  provideRouterStore({
    stateKey: 'router',
  }),

  provideStoreDevtools({
    name: 'romeo',
    maxAge: 25,
    logOnly: !isDevMode(),
  }),
];
